import { Controller } from "@hotwired/stimulus"

// The zone follows the town when the town is one of the kommune's: the select
// shows that zone and is disabled, so it is not sent and the server derives
// it. Only when the town is "Andet", blank, or one nobody has put in a zone
// does the zone select take a hand-picked answer. Mirrors
// Member#assign_zone_from_town, which is where the rule actually lives.
export default class extends Controller {
  static targets = ["town", "zone"]

  connect() {
    this.follow(false)
  }

  sync() {
    this.follow(true)
  }

  follow(townChanged) {
    const option = this.townTarget.selectedOptions[0]
    const group  = option && option.parentElement.tagName === "OPTGROUP" ? option.parentElement.label : ""

    if (group) {
      this.zoneTarget.value = group
    } else if (townChanged) {
      // The old town's zone must not ride along into a town that has none.
      this.zoneTarget.value = ""
    }
    this.zoneTarget.disabled = Boolean(group)
  }
}
